<template>
  <v-alert outlined color="orange" class="text-center">
    <div class="font-weight-medium mb-2">{{ titleText }}</div>
    <div class="grey--text font-italic">
      без&nbsp;регистрации
      <br />в&nbsp;Личном&nbsp;кабинете
    </div>
  </v-alert>
</template>
<script>
export default {
  name: "reading-instructions",
  props: {
    titleText: {
      type: String,
      default: "Инструкция по оплате за электроэнергию"
    }
  }
};
</script>